import { Logger } from './app/utilitites/logger';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
var telemetryConfiguration = window["TelemetryConfiguration"];
var appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: telemetryConfiguration.instrumentationKey
  }
});

var TelemetryInitializer = function TelemetryInitializer(envelope) {
  envelope.data.AppRoleName = telemetryConfiguration.appRoleName;

  if (sessionStorage["bridgeId"]) {
    envelope.data.bridgeId = sessionStorage["bridgeId"];
  }

  if (sessionStorage["userId"]) {
    envelope.data.userId = sessionStorage["userId"];
  }

  if (sessionStorage["application_SessionId"]) {
    envelope.data.sessionId = sessionStorage["application_SessionId"];
  }

  var networkConnection = getNetworkConnection();

  if (networkConnection) {
    envelope.data.networkType = networkConnection.effectiveType;
    envelope.data.networkSpeed = networkConnection.downlink;
  }

  try {
    if (bowser) {
      var _result$parsedResult$;

      var result = bowser.getParser(window.navigator.userAgent);
      envelope.data.bowserName = result.parsedResult.browser.name;
      envelope.data.bowserVersion = result.parsedResult.browser.version;
      envelope.data.operatingSystem = result.parsedResult.os.name;
      envelope.data.operatingSystemVersion = (_result$parsedResult$ = result.parsedResult.os.versionName) !== null && _result$parsedResult$ !== void 0 ? _result$parsedResult$ : result.parsedResult.os.version;
      envelope.data.platform = result.parsedResult.platform.type;
    }
  } catch (_unused) {}
};

var getNetworkConnection = function getNetworkConnection() {
  if (!navigator) return "";
  return navigator.connection || navigator.mozConnection || navigator.webkitConnection;
};

appInsights.loadAppInsights();
appInsights.addTelemetryInitializer(TelemetryInitializer);
var logger = Logger.getInstance();
logger.init(appInsights, telemetryConfiguration);
window["Logger"] = logger;